import { getCookie, decryptAes } from '../../utils';

const getParams = (values) => {
  const params = Object.keys(values).reduce((acc, key) => {
    if (values[key]) {
      acc[key] = values[key];
    }

    return acc;
  }, {});

  return new URLSearchParams({
    ...params
  });
}

const list = async ({ path, values }) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  const response = await fetch(`${process.env.REACT_APP_HOST_API}/${path}?${getParams(values)}`, {
    method: 'GET',
    signal: AbortSignal.timeout(5000),
    headers: {
      token: decipher.token.value,
      action: 'search',
    },
  });

  return await response.json();
}

export default list;
